import React,{useEffect} from "react";
import { Autocomplete, TextField } from "@mui/material";
import "react-datepicker/dist/react-datepicker.css";
import "../../../Styles/reactDatePicker.scss";

export default function PeriodFilter({ dateRange, setDateRange }) {
  const periodFilterOptions = [
    { label: "Last Month", value: () => getLastMonthRange() },
    { label: "Last Week", value: () => getLastWeekRange() },
    { label: "Last 7 Days", value: () => getLast7DaysRange() },
    { label: "This Month", value: () => getThisMonthRange() },
    { label: "Last Three Months", value: () => getLastThreeMonthsRange() },
  ];

  // Helper functions to calculate date ranges
  const getLastMonthRange = () => {
    const now = new Date();
    const firstDayLastMonth = new Date(now.getFullYear(), now.getMonth() - 1, 1);
    const lastDayLastMonth = new Date(now.getFullYear(), now.getMonth(), 0);
    return [firstDayLastMonth, lastDayLastMonth];
  };

  const getLastWeekRange = () => {
    const now = new Date();
  
    // Get the current day of the week (0 = Sunday, 1 = Monday, ..., 6 = Saturday)
    const currentDay = now.getDay();
  
    // Calculate the end of last week (last Sunday)
    const lastWeekEnd = new Date(now);
    lastWeekEnd.setDate(now.getDate() - currentDay - 1); // Move to last Sunday
  
    // Calculate the start of last week (last Monday)
    const lastWeekStart = new Date(lastWeekEnd);
    lastWeekStart.setDate(lastWeekEnd.getDate() - 6); // Move to last Monday
  
    // Reset time to the start and end of the day
    lastWeekStart.setHours(0, 0, 0, 0); // Start of the day
    lastWeekEnd.setHours(23, 59, 59, 999); // End of the day
  
    return [lastWeekStart, lastWeekEnd];
  };
  

  const getLast7DaysRange = () => {
    const now = new Date();
  
    // Calculate the end of the range (yesterday)
    const last7DaysEnd = new Date(now);
    last7DaysEnd.setDate(now.getDate() - 1); // Move to yesterday
    last7DaysEnd.setHours(23, 59, 59, 999); // End of the day
  
    // Calculate the start of the range (7 days before yesterday)
    const last7DaysStart = new Date(last7DaysEnd);
    last7DaysStart.setDate(last7DaysEnd.getDate() - 6); // Move back 6 more days
    last7DaysStart.setHours(0, 0, 0, 0); // Start of the day
  
    return [last7DaysStart, last7DaysEnd];
  };
  

  const getThisMonthRange = () => {
    const now = new Date();
    const firstDayThisMonth = new Date(now.getFullYear(), now.getMonth(), 1);
    const today = new Date();
    return [firstDayThisMonth, today];
  };

  const getLastThreeMonthsRange = () => {
    const now = new Date();
    const threeMonthsAgo = new Date(now.getFullYear(), now.getMonth() - 3, 1);
    const lastDayLastMonth = new Date(now.getFullYear(), now.getMonth(), 0);
    return [threeMonthsAgo, lastDayLastMonth];
  };
  useEffect(() => {
    if (!dateRange[0] && !dateRange[1]) {
      const [start, end] = getThisMonthRange(); // Set default to "This Month"
      setDateRange([start, end]);
    }
  }, [dateRange, setDateRange]);

  return (
      // Period Filter 
      <div className="datePickerWrapper">

          <Autocomplete
            disablePortal
            options={periodFilterOptions}
            getOptionLabel={(option) => option.label}
            onChange={(event, newValue) => {
              if (newValue) {
                const [start, end] = newValue.value();
                setDateRange([start, end]); // Pass date range to parent component
              } else {
                setDateRange([null, null]); // Clear the date picker values
              }
            }}
            sx={{
              marginLeft: "15px",
              backgroundColor: "white",
              "& .MuiInputBase-root": {
                height: 39,
                padding: "0 8px",
              },
              "& .MuiOutlinedInput-notchedOutline": {
                borderColor: "#ccc",
              },
              "& .MuiAutocomplete-input": {
                padding: "0 !important",
                // width: "225px !important"
              },
              "@media (max-width: 600px)": {
          marginLeft: "0",
        },
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Period Filter"
                InputLabelProps={{
                  sx: {
                    fontSize: "0.875rem",
                    transform: "translate(14px, 8px) scale(1)",
                    "&.MuiInputLabel-shrink": {
                      transform: "translate(14px, -5px) scale(0.75)",
                    },
                  },
                }}
              />
            )}
          />
      </div>
  );
}
